import { get, postJSON, post } from "./request";

export const taskInfo = data => post("/task/patrol/logs", data);



// WEBPACK FOOTER //
// ./src/assets/api/InspectionRecordMG.js